import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-24" data-id="element-29" data-mp="gxzvn96yz5t4">
      <Reveal className="mx-auto max-w-3xl" data-id="element-30" data-mp="vtnvkm5996r7">
        <div className="mb-12 text-center" data-id="element-31" data-mp="qtt52jpe6j6o">
          <p className="text-[10px] font-extrabold uppercase tracking-[0.22em] text-brand-orange sm:text-xs" data-id="element-32" data-mp="qsrx4o3oact6">
            Empfohlen
          </p>
          <h2 className="mt-4 flex items-center justify-center gap-3 text-3xl font-extrabold text-brand-navy md:text-4xl" data-id="element-33" data-mp="14r81i8e2br85">
            <GiftIcon className="h-7 w-7 shrink-0 text-brand-orange" aria-hidden="true" data-id="element-34" data-mp="1ejx92s6hsky7" />
            5 exklusive Boni
          </h2>
          <p className="mt-4 text-sm text-brand-gray md:text-base" data-id="element-35" data-mp="19mncmskor90v">
            Im Wert von über{' '}
            <span className="font-bold text-brand-navy" data-id="element-36" data-mp="1nhpso8j8yere">130 €</span> — gratis
            für dich.
          </p>
        </div>
        <div className="space-y-3" data-id="element-37" data-mp="3pqttoki7txeu">
          {bonuses.map(bonus => <article key={bonus.title} className="flex items-center gap-4 rounded-2xl border border-brand-line bg-brand-alt p-4 shadow-sm sm:gap-5" data-id="element-38" data-mp="3trxapac01zhn">
              <img src={bonus.cover} alt={`Cover Bonus ${bonus.title}`} className="h-20 w-14 shrink-0 rounded-md border border-brand-line object-cover shadow-sm sm:h-24 sm:w-[4.25rem]" loading="lazy" data-id="element-39" data-mp="2nywa4nozx9p" />
              <div className="min-w-0 flex-1" data-id="element-40" data-mp="gjkhs1upvyxd">
                <h3 className="font-bold leading-snug text-brand-navy" data-id="element-41" data-mp="lblpdagxx1h2">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-xs leading-relaxed text-brand-gray sm:text-sm" data-id="element-42" data-mp="qa5f7lynmxep">
                  {bonus.description}
                </p>
              </div>
              <div className="shrink-0 text-right" data-id="element-43" data-mp="1094lwyzv0iz2">
                <p className="text-[10px] font-bold uppercase tracking-[0.1em] text-brand-gray" data-id="element-44" data-mp="109wavqyybigd">
                  Wert
                </p>
                <p className="font-display text-lg font-extrabold text-brand-orange" data-id="element-45" data-mp="5m5q61b1uxhf">
                  {bonus.value}
                </p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}